export function HuiTabs() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            sizing: '@'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-tabs"
                     ng-class="[$huiCtrl.sizing || 'md']" 
                     ng-transclude>
                </div>
            `;
        }
    }
}